module.exports = {"type":"Municipal Plan","urban":[{"name":"Urban Structure","layer":"toronto urban structure","toggle":false}],"rowwidth":[{"name":"Right-of-Way Widths (Major Streets)","layer":"right of way","toggle":false}],"urbanstructure":[{"error":""}],"rightofway":[{"error":""}]}


//////////////////
// WEBPACK FOOTER
// ./public/data/municipal_plan_sidebar.json
// module id = RR8b
// module chunks = 1